// src/hooks/useAffixNavbar.js
import { useEffect } from "react";
export const useAffixNavbar = () => {
  useEffect(() => {
    const nav = document.querySelector(".navbar-desctop");
    if (!nav) return;

    const onScroll = () => {
      const fn = window.scrollY > 200 ? "add" : "remove";
      nav.classList[fn]("affix", "animated", "slideInDown");
    };
    onScroll(); // run once at mount
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);
};

export default useAffixNavbar;
